import { HuaweiBridgeClient } from './huawei-bridge-client';
/**
 * ShareHuawei implements the same SharePlugin interface as @capacitor/share,
 * routing calls through the Huawei JS Bridge.
 *
 * Backed by HarmonyOS Share Kit: share() opens the system share panel
 * (systemShare.ShareController.show). The promise resolves once the panel
 * is presented — user completion is not awaited (matching Android).
 */
export class ShareHuawei {
    constructor() {
        this.bridge = HuaweiBridgeClient.getInstance();
    }
    /**
     * The system share panel is always available on HarmonyOS devices,
     * so this resolves locally without a bridge round trip.
     */
    async canShare() {
        return { value: true };
    }
    async share(options) {
        const params = {};
        if (options.title !== undefined) {
            params.title = options.title;
        }
        if (options.text !== undefined) {
            params.text = options.text;
        }
        if (options.url !== undefined) {
            params.url = options.url;
        }
        const res = await this.bridge.call('shareShare', params);
        return res || { activityType: '' };
    }
}
//# sourceMappingURL=share.js.map